// Posters ship as data-poster (a <video> poster cannot be lazy); set the real attribute near the viewport.
function hbApplyPoster(video) {
  if (video && video.dataset.poster && !video.getAttribute("poster")) {
    video.setAttribute("poster", video.dataset.poster);
  }
}

// sections/pdp-routine.liquid emits this script once per routine section, and campaign pages such as
// page.ramadan-campaign render two or three.
// Each copy runs, and each set up every section, so listeners and observers were bound twice.
if (!window.__hbRoutineVideoLoaded) {
  window.__hbRoutineVideoLoaded = true;
  document.addEventListener("DOMContentLoaded", function () {
    const routineSections = document.querySelectorAll(".routine-pdp");

    routineSections.forEach((section) => {
      // Visible posters (preview clips and standard videos) load about 1200px ahead of the section, carousel
      // items included; full-video posters load when their preview is on screen or on play.
      const nearPosters = section.querySelectorAll(".routine-preview-video[data-poster], .routine-main-video[data-poster]");
      if (nearPosters.length) {
        if ("IntersectionObserver" in window) {
          const posterObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              posterObserver.disconnect();
              nearPosters.forEach(hbApplyPoster);
            },
            { rootMargin: "1200px 0px" }
          );
          posterObserver.observe(section);
        } else {
          nearPosters.forEach(hbApplyPoster);
        }
      }

      const previewWrappers = section.querySelectorAll('[data-autoplay-preview="true"]');
      const standardWrappers = section.querySelectorAll(
        ".routine-media-wrapper:not([data-autoplay-preview])"
      );
      const allFullVideos = [];

      function loadVideoSources(video) {
        const sources = video.querySelectorAll("source[data-src]");
        if (sources.length === 0) return;
        sources.forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute("data-src");
        });
        video.load();
      }

      function pauseAllFullVideosExcept(current) {
        allFullVideos.forEach((entry) => {
          if (entry.video !== current && !entry.video.paused) {
            entry.video.pause();
          }
        });
      }

      /* ── Preview-enabled wrappers (preview clip + full video) ── */
      previewWrappers.forEach((wrapper) => {
        const previewVideo = wrapper.querySelector(".routine-preview-video");
        const fullVideo = wrapper.querySelector(".routine-full-video");
        if (!previewVideo || !fullVideo) return;

        const previewControl = wrapper.querySelector('video-playback-control');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const canAutoplayPreview = () => !reducedMotion.matches && previewControl?.dataset.userPaused !== 'true';
        let previewSourcesLoaded = false;
        let fullSourcesLoaded = false;

        allFullVideos.push({ video: fullVideo, wrapper: wrapper });

        function startFullPlayback() {
          hbApplyPoster(fullVideo);
          pauseAllFullVideosExcept(fullVideo);
          previewVideo.pause();
          wrapper.classList.add("is-playing");

          if (!fullSourcesLoaded) {
            loadVideoSources(fullVideo);
            fullSourcesLoaded = true;
          }
          fullVideo.currentTime = 0;
          fullVideo.play().catch(() => {});
          if (wrapper.querySelector('.routine-play-btn') === document.activeElement) {
            fullVideo.tabIndex = 0;
            fullVideo.focus();
          }
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                hbApplyPoster(previewVideo);
                hbApplyPoster(fullVideo);
                if (!previewSourcesLoaded) {
                  loadVideoSources(previewVideo);
                  previewSourcesLoaded = true;
                }
                if (!wrapper.classList.contains("is-playing") && canAutoplayPreview()) {
                  previewVideo.muted = true;
                  previewVideo.currentTime = 0;
                  previewVideo.play().catch(() => {});
                }
              } else {
                previewVideo.pause();
                fullVideo.pause();
              }
            });
          },
          { root: null, rootMargin: "0px", threshold: 0.25 }
        );
        observer.observe(wrapper);

        fullVideo.addEventListener("play", function () {
          pauseAllFullVideosExcept(fullVideo);
        });

        wrapper.addEventListener("click", function (e) {
          if (e.target.closest("a")) return;
          if (wrapper.classList.contains("is-playing")) return;
          startFullPlayback();
        });

        fullVideo.addEventListener("ended", function () {
          if (document.fullscreenElement) {
            document.exitFullscreen().catch(() => {});
          } else if (document.webkitFullscreenElement) {
            document.webkitExitFullscreen();
          } else if (fullVideo.webkitDisplayingFullscreen) {
            fullVideo.webkitExitFullscreen();
          }
          wrapper.classList.remove("is-playing");
          fullVideo.currentTime = 0;
          if (canAutoplayPreview()) previewVideo.play().catch(() => {});
          if (document.activeElement === fullVideo) wrapper.querySelector('.routine-play-btn')?.focus();
        });
      });

      /* ── Standard (non-preview) videos ── */
      standardWrappers.forEach((wrapper) => {
        const video = wrapper.querySelector(".routine-main-video");
        if (!video) return;

        let sourcesLoaded = false;
        allFullVideos.push({ video: video, wrapper: null });

        video.addEventListener("play", () => {
          pauseAllFullVideosExcept(video);
        });

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                hbApplyPoster(video);
                if (!sourcesLoaded) {
                  loadVideoSources(video);
                  sourcesLoaded = true;
                }
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { root: null, rootMargin: "0px", threshold: 0.25 }
        );
        observer.observe(wrapper);
      });
    });
  });
}
